module.exports = __webpack_public_path__ + "img/email-mdi.bdf6cdf0.svg";